import React, { useState, useEffect } from 'react';
import { Spin, Empty, Tag, Card, Row, Col, Typography, Button } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import CustomList from '../../components/List';
import ListItem from '../../components/ListItem';
import CustomPagination from '../../components/CustomPagination';
import API from '../../../API';

const { Text, Title } = Typography;

const ProjectRegionsTab = ({ 
    projectId,
    onOpenSummaryModal
}) => {
    const [regions, setRegions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedRegionId, setSelectedRegionId] = useState(null);
    const [pagination, setPagination] = useState({
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1
    });
    const [currentPage, setCurrentPage] = useState(1);

    const fetchRegions = async (page = 1, pageSize = pagination.per_page) => {
        if (!projectId) return;
        
        setLoading(true);
        try {
            const response = await API.getProjectRegions(projectId, page, pageSize);
                
            let regionsData = [];
            let paginationData = pagination;
            
            if (response && response?.data?.data) {
                regionsData = response.data.data;
            } else if (Array.isArray(response?.data)) {
                regionsData = response?.data;
            }
            
            if (response && response?.data?.pagination) {
                paginationData = response?.data?.pagination;
            }
            
            setRegions(regionsData);
            setPagination(paginationData);
        } catch (error) {
            console.error('Error fetching regions:', error);
            setRegions([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRegions();
    }, [projectId]);

    const handleRegionsPageChange = (page, pageSize) => {
        setCurrentPage(page);
        fetchRegions(page, pageSize);
    };



    if (loading && regions.length === 0) {
        return (
            <div style={{ textAlign: 'center', padding: '50px' }}>
                <Spin size="large" />
            </div>
        );
    }

    if (!loading && regions.length === 0) {
        return (
            <Empty 
                description="No regions found for this project"
                style={{ margin: '50px 0' }}
            />
        );
    }

    return (
        <Card>
            <Row gutter={[16, 16]}>
                <Col xs={24} lg={24}>
                    <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Title level={4} style={{ margin: 0 }}>Project Regions</Title>
                    </div>
                    <div>
                        {loading ? (
                            <Spin />
                        ) : (
                            <>
                                <CustomList
                                    itemName="Regions"
                                    items={regions}
                                    page={currentPage}
                                    itemCount={pagination?.total || (regions?.length || 0)}
                                    loading={loading}
                                    headerLayout={[
                                        { xxl: 8, xl: 8, lg: 8, md: 8, sm: 24, xs: 24, header: 'Name' },
                                        { xxl: 4, xl: 4, lg: 4, md: 4, sm: 24, xs: 24, header: 'Actions' }
                                    ]}
                                    renderListItem={({ item }) => (
                                        <ListItem
                                            key={item.id}
                                            name={item.name}
                                            item={item}
                                            isPackage={false}
                                            className={selectedRegionId === item.id ? 'selected' : ''}
                                            onClick={() => setSelectedRegionId(item.id)}
                                        >
                                            <Row gutter={[8, 0]} style={{ width: '100%' }}>
                                                <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24} className="contentEllipse">
                                                    <div className="mobile-label">Name</div>
                                                    <Text strong>{item.name}</Text>
                                                </Col>
                                                <Col xxl={4} xl={4} lg={4} md={4} sm={24} xs={24} className="contentEllipse">
                                                    <div className="mobile-label">Actions</div>
                                                    <div style={{ width: '100%', justifyContent: 'center', alignItems: 'start', position: 'relative', zIndex: 10 }}>
                                                        <Button
                                                            type="text"
                                                            icon={<SettingOutlined />}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                if (onOpenSummaryModal) {
                                                                    onOpenSummaryModal(item.id, item.name);
                                                                }
                                                            }}
                                                            size="large"
                                                            title="Summary Settings"
                                                            style={{ pointerEvents: 'auto', cursor: 'pointer' }}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </ListItem>
                                    )}
                                    showToolbar={false}
                                />
                                
                                {pagination && pagination.total > 0 && (
                                    <CustomPagination 
                                        pagination={pagination}
                                        onPageChange={handleRegionsPageChange}
                                        loading={loading}
                                    />
                                )}
                            </>
                        )}
                    </div>
                </Col>
            </Row>
        </Card>
    );
};

export default ProjectRegionsTab;
